import damarbatu1 from "../assets/damar-batu-1.jpeg"
import damarbatu2  from "../assets/damar-batu-2.jpeg"
import damarbatu3  from "../assets/damar-batu-3.jpeg"


const DammarBatuData = [

    {
        imgsrc: damarbatu1, 
        title: "Damar Batu Bombay",
        text: "Damar Batu Bombay is a variation of Damar Batu. Damar Batu Bombay has large and looks like a rock chunk. The Bombay variant is often used as an ingredient to make incense."
    },
    {
        imgsrc: damarbatu2, 
        title: "Damar Batu Calcuta",
        text: "Damar Batu Calcuta is a variation of Batu Damar. Damar Batu Calcuta has smaller size rather than the Bombay variant and looks like pebbles. The Calcutta variant is often used in perfumery, incense and paint blends."
    },
    {
        imgsrc: damarbatu3, 
        title: "Damar Batu Mix Quality",
        text: "Damar Batu Mix Quality is a combination of Bombay and Calcuta variants such that the proposed texture includes small and large portions."
    }
]

export default DammarBatuData;





